

export class Formatter {
	public static formatNumber(ANumber: number, ADecimais: number = 0, ACharDecimais: string = ',', ACharMilhar: string = '.') {
		return Formatter.formatMoney(ANumber, ADecimais,ACharDecimais, ACharMilhar,  '');
	}

	public static formatMoney(ANumber: number, 
		ADecimais: number = 2, 
		  AVirgula: string = ',', 
		  ACharMilhar: string = '.', simbol?: string): string {
		if (simbol == null)
			simbol = '';
		var n = ANumber,
		    ADecimais = isNaN(ADecimais = Math.abs(ADecimais)) ? 2 : ADecimais,
			AVirgula = AVirgula == undefined ? "." : AVirgula,
			ACharMilhar = ACharMilhar == undefined ? "," : ACharMilhar,
			s = n < 0 ? "-" : "",
			n = Math.abs(+n || 0),
			i = parseInt(n.toFixed(ADecimais)) + "",
			j = (j = i.length) > 3 ? j % 3 : 0;
		return simbol + s + (j ? i.substr(0, j) + ACharMilhar : "") + 
		i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ACharMilhar) + 
		(ADecimais ? AVirgula + 
		Math.abs(n - (<any>i)).toFixed(ADecimais).slice(2) : "");
	};


	public static getDataAtual(): string {
		
		let data = new Date()

		return Formatter.getDafaultDateFormat(data)
	  
	}
	private static getDafaultDateFormat(data : Date) : string 
	{
      	
		let mes = data.getMonth() + 1;
		let dia = data.getDate();
		let ano = data.getFullYear();
		return `${mes.toString().padStart(2,'0')}/${dia.toString().padStart(2,'0')}/${ano.toString()}`;
	}

	public static getDataDefault(value?): string 
	{
		let data =  new Date()
		if(value)
		{
            data = new Date(value)
		}
		

		return data.toLocaleDateString('pt-BR', {timeZone: 'UTC'})
		
	}

}



